// extracted by mini-css-extract-plugin
export var activeFilterButton = "_q8-c";
export var backButton = "_q8-4";
export var backIcon = "_q8-5";
export var chevronShortcut = "_q8-6";
export var container = "_q8-1";
export var editor = "_q8-8";
export var editorWrapper = "_q8-7";
export var prefix = "_q8-2";
export var searchIcon = "_q8-3";
export var suffix = "_q8-9";
export var suffixContent = "_q8-a";
export var suffixText = "_q8-b";
export var wrapper = "_q8-0";